import { History } from 'history';
import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { getAjaxhelper } from '../utils/index';
import { RoomAvailabilityListDetail } from './RoomAvailabilityListDetail';
import { HotelBedCatalogData } from 'src/shared';
import { ModalWrapper } from 'src/core';
import { ShowRoomDetail } from './ShowRoomDetail';
import { ShowRoomsDetail } from './ShowRoomsDetail';
export interface RoomAvailabilityListProps extends BaseComponentProps {
    currencyCode: string;
    history: History;
    reqAvailableDetailId: number;
    // promotionLineData: (boardName: string, classHotels: string, classPromoLine: string, textPromoLine: string, classHaveoffer: string, offerRate: number, minRate: number) => any;
    night: string;
    classright: string;
    firebaseApp: firebase.app.App;
    reqKey: string;
    lang: string;
    roomShow?: number;
    sameWindow?: boolean;
}
export interface RoomAvailabilityListState extends BaseComponentState {
    classHaveoffer: string;
    offerRate: number;
    classHotels: string;
    classPromoLine: string;
    textPromoLine: string;
    iconPlus: any;
    hotelDesriptionClass: string;
    btnClickNoteText: string;
    roomRates: any[];
    requesting: boolean;
    dataRoomRate: any;
    showAll: boolean;
    roomOpen: boolean;
    roomCode: string;
    roomName: string;
}

export class RoomAvailabilityList extends BaseComponent<RoomAvailabilityListProps, RoomAvailabilityListState> {

    constructor(props: RoomAvailabilityListProps) {
        super(props);
        this.state = {
            classHaveoffer: 'hide',
            offerRate: 0,
            classHotels: '',
            classPromoLine: 'hide',
            textPromoLine: '',
            iconPlus: <i className="fa fa-minus-square-o" />,
            hotelDesriptionClass: 'short-description',
            btnClickNoteText: 'Read More',
            roomRates: [],
            requesting: true,
            dataRoomRate: {},
            showAll: false,
            roomOpen: false,
            roomCode: '',
            roomName: ''
        };
    }

    componentDidMount() {
        this.getData();

    }

    getData() {
        getAjaxhelper().post("/dynamics/hb-api/hotels-availability-room-rates", { reqAvailableDetailId: this.props.reqAvailableDetailId, currencyCode: this.props.currencyCode }).then(
            d => {
                this.setStateHelper(
                    st => {
                        st.dataRoomRate = d;
                        st.requesting = false;
                    }
                );
            }).catch(exc => {
                console.log(exc);
            });
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let RoomsVailable: any[] = [];
        let RoomsVailableAll: any[] = [];
        let roomshow = this.props.roomShow ? this.props.roomShow : 3;
        if (this.state.requesting === false) {
            if (this.state.dataRoomRate && this.state.dataRoomRate.roomData && this.state.dataRoomRate.roomData.length > 0) {
                let lop = 0;
                let rData: HotelBedCatalogData.ReqHotelAvailableRateDetail[] = this.state.dataRoomRate.roomData;
                let indexRoomData: { [roomName: string]: any[] } = {};
                for (let roomData of rData) {
                    if (!indexRoomData[roomData.roomName!]) {
                        indexRoomData[roomData.roomName!] = [];
                    }
                    indexRoomData[roomData.roomName!].push(roomData);
                }

                for (let roomName of Object.keys(indexRoomData)) {
                    let roomFullCode: string[] = [];
                    let roomsName: string[] = [];
                    let romromData = indexRoomData[roomName];
                    let rateDetail = JSON.parse(romromData[0].rateDetail);
                    let namaKamar: any[] = [];
                    let ll = 0;
                    for (let r of Object.keys(rateDetail)) {
                        let kali = "";
                        if (rateDetail[r].jumlah > 1) {
                            kali = `${rateDetail[r].jumlah} x `;
                        }
                        if (ll > 0) {
                            namaKamar.push(<span> + </span>);
                        }
                        roomFullCode.push(rateDetail[r].roomFullCode);
                        roomsName.push(rateDetail[r].roomName);
                        namaKamar.push(
                            <a
                                href="javascript:void(0)"
                                onClick={
                                    () => {
                                        this.setStateHelper(
                                            st => {
                                                st.roomOpen = true;
                                                st.roomCode = rateDetail[r].roomFullCode;
                                                st.roomName = rateDetail[r].roomName;
                                            }
                                        );
                                    }
                                }
                            >
                                {kali} {rateDetail[r].roomName}
                            </a>

                        );
                        ll++;
                    }
                    let kamarsWithImage = <ShowRoomsDetail roomIds={roomFullCode} roomsName={roomsName} lang={this.props.lang} />;
                    RoomsVailableAll.push(
                        <tr className=" " key={`RoomsVailableAll${lop}${lop}`}>
                            <td rowSpan={indexRoomData[roomName].length + 1} style={{ borderRight: '1px solid #e2e2e4', verticalAlign: 'top' }}>{kamarsWithImage}</td>
                            <td colSpan={5} style={{ background: '#f3f5f5', fontSize: 13, fontWeight: 800 }}>{namaKamar}</td>
                        </tr>);
                    if (lop < roomshow) {
                        RoomsVailable.push(
                            <tr className=" " key={`RoomsVailableAll${lop}${lop}`}>
                                <td rowSpan={indexRoomData[roomName].length + 1} style={{ borderRight: '1px solid #e2e2e4', verticalAlign: 'top' }}>{kamarsWithImage}</td>
                                <td colSpan={5} style={{ background: '#f3f5f5', fontSize: 13, fontWeight: 800 }}>{namaKamar}</td>
                            </tr>
                        );
                    }
                    for (let roomData of romromData) {
                        /**
                         * TODO: Ada update state juka RoomAvailabilityListDetail sudah di check rate dan sudah dpt hasil
                         */
                        RoomsVailableAll.push(<RoomAvailabilityListDetail history={this.props.history} lang={this.props.lang} sameWindow={this.props.sameWindow} reqKey={this.props.reqKey} night={this.props.night} firebaseApp={this.props.firebaseApp} key={`RoomsVailableAll${lop}`} roomData={roomData} currencyCode={this.props.currencyCode} />);
                        if (lop < roomshow) {
                            RoomsVailable.push(<RoomAvailabilityListDetail history={this.props.history} lang={this.props.lang} sameWindow={this.props.sameWindow} reqKey={this.props.reqKey} night={this.props.night} firebaseApp={this.props.firebaseApp} key={`RoomsVailable${lop}`} roomData={roomData} currencyCode={this.props.currencyCode} />);
                        }
                        lop++;
                    }

                }
            }
        } else {
            return (
                <div className="col-md-12 bg-white" style={{ minHeight: 300, textAlign: "center", paddingTop: '10%' }}>
                    <h4>Please Wait</h4>
                    <div className='loader' />
                </div>
            );
        }
        let tableHeader = (
            <tr>
                <th className="desktop-only">Room/s</th>
                <th className="desktop-only">Board</th>
                <th className="desktop-only">Booking Policy</th>
                <th className="desktop-only">For {this.props.night} Night</th>
                <th className="desktop-only">Book Online</th>
                <th className="mobile-only">Room Options</th>
            </tr>
        );
        let showRoom: any[] = [];
        if (this.state.showAll) {
            showRoom = RoomsVailableAll;
        } else {
            showRoom = RoomsVailable;
        }
        let showMore = <span />;
        if (RoomsVailableAll.length !== RoomsVailable.length) {
            showMore = (
                <a
                    className={`${this.props.classright}`}
                    style={{ lineHeight: '35px', marginRight: 0, paddingLeft: 5, position: 'inherit', display: 'block', background: '#ffd34a', color: '#f86427', fontSize: 15, borderRadius: '0 0 5px 5px', fontWeight: 800 }}
                    onClick={() => {
                        this.setStateHelper(
                            st => {
                                if (st.showAll) {
                                    st.showAll = false;
                                    st.iconPlus = <i className="fa fa-plus-square-o" />;
                                } else {
                                    st.showAll = true;
                                    st.iconPlus = <i className="fa fa-minus-square-o" />;
                                }
                            });
                    }}
                > {this.state.iconPlus} {this.state.showAll ? `See Less Room Options` : `Click Here For More Rooms`}
                </a>
            );
        }
        let style2: ReactModal.Styles = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0, 0.75)',
                zIndex: 9999
            },
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                overflow: 'hidden',
                backgroundColor: '#fff',
                border: 0
            }
        };
        return (
            <div>
                <ModalWrapper
                    style={style2}
                    isOpen={this.state.roomOpen}
                    onRequestClose={this.hendlerRoomDetailClose}
                    role="dialog"
                    contentLabel="Minimal Modal Example"
                ><div className="show-room-detail">
                        <ShowRoomDetail roomId={this.state.roomCode} roomName={this.state.roomName} hendlerRoomDetailClose={this.hendlerRoomDetailClose} lang={this.props.lang} />
                    </div>
                </ModalWrapper>
                <table className={`table   ${this.props.classright}`} style={{ borderTop: '1px solid #eee' }}>
                    <thead >
                        {tableHeader}
                    </thead>
                    <tbody>
                        {showRoom}
                    </tbody>
                </table>
                {showMore}
            </div>
        );
    }

    hendlerRoomDetailClose: () => any = () => {
        this.setState({ roomOpen: false });
    }
}   


// WEBPACK FOOTER //
// ./src/hotels/RoomAvailabilityList.tsx